import { useEffect, useState, useCallback } from "react";
import { Mail, MailOpen, CheckCheck } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Loading, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";

export default function Messages() {
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(null);

  const load = useCallback(() => { api.get("/messages").then(({ data }) => setItems(data)); }, []);
  useEffect(() => { load(); }, [load]);

  const open = async (m) => {
    setSel(m);
    if (!m.read) { await api.post(`/messages/${m.id}/read`); load(); window.dispatchEvent(new Event("wcc:unread")); }
  };
  const readAll = async () => { await api.post("/messages/read-all"); load(); window.dispatchEvent(new Event("wcc:unread")); };

  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader title="メール" subtitle="サイト内のお知らせ・職員周知・受講リマインド"
        actions={items.some((m) => !m.read) && <Button variant="outline" onClick={readAll} data-testid="read-all-btn"><CheckCheck className="w-4 h-4 mr-1" /> すべて既読</Button>} />
      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-1 bg-white rounded-xl border border-slate-200 divide-y divide-slate-100 overflow-hidden max-h-[72vh] overflow-y-auto">
          {items.length ? items.map((m) => (
            <button key={m.id} onClick={() => open(m)} data-testid={`msg-${m.id}`}
              className={`w-full text-left p-4 hover:bg-slate-50 transition-colors ${sel?.id === m.id ? "bg-blue-50" : ""}`}>
              <div className="flex items-center gap-2">
                {m.read ? <MailOpen className="w-4 h-4 text-slate-300 shrink-0" /> : <Mail className="w-4 h-4 text-blue-600 shrink-0" />}
                <span className={`text-sm truncate ${m.read ? "text-slate-500" : "font-semibold text-slate-800"}`}>{m.subject}</span>
              </div>
              <div className="text-xs text-slate-400 mt-1 flex justify-between"><span className="truncate">{m.from_name}</span><span className="shrink-0 ml-2">{(m.created_at || "").slice(5, 10)}</span></div>
            </button>
          )) : <EmptyState title="メールはありません" />}
        </div>
        <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 p-6 min-h-[300px]">
          {sel ? (
            <div className="wcc-fadein">
              <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded">{sel.category}</span>
              <h2 className="text-lg font-bold text-slate-900 mt-2">{sel.subject}</h2>
              <div className="text-xs text-slate-400 mt-1 mb-4">差出人：{sel.from_name}・{(sel.created_at || "").slice(0, 16).replace("T", " ")}</div>
              <p className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">{sel.body}</p>
            </div>
          ) : <div className="text-slate-400 text-sm flex items-center justify-center h-full">メールを選択してください</div>}
        </div>
      </div>
    </div>
  );
}
